import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CustomDialog } from 'components/shared/Dialog/CustomDialog';
import { MatchedRecordDetailsCard } from './MatchedRecordDetailsCard';

interface Props {
  isOpen: boolean;
  submitting: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  matchConfidence: number | null;
  linkUrl: string | null;
  applicantName: string | null;
  contactName: string | null;
  equipmentDescription: string | null;
  requestedAmount: number | null;
  dealerName: string | null;
}

export const UpdateExistingSubmissionModal = ({
  isOpen,
  submitting,
  onClose,
  onConfirm,
  matchConfidence,
  linkUrl,
  applicantName,
  contactName,
  equipmentDescription,
  requestedAmount,
  dealerName,
}: Props) => (
  <CustomDialog
    isOpen={isOpen}
    onClose={onClose}
    label="Update Existing Submission"
    actions={
      <>
        <Button variant="outlined" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={submitting}>
          Update Submission
        </Button>
      </>
    }
  >
    <Stack spacing={2}>
      <Typography variant="body1">
        A matching submission was found. The submission will be updated with the confirmed application data and
        supporting documents.
      </Typography>

      <MatchedRecordDetailsCard
        sectionLabel="Matched Submission"
        matchConfidence={matchConfidence}
        linkUrl={linkUrl}
        applicantName={applicantName}
        contactName={contactName}
        equipmentDescription={equipmentDescription}
        requestedAmount={requestedAmount}
        dealerName={dealerName}
      />
    </Stack>
  </CustomDialog>
);
